import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageVisit, initializeTracking } from '../firebase/analyticsService';

const AnalyticsTracker: React.FC = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Initialize tracking once when component mounts
    const { sessionId, isNewUser } = initializeTracking();
    
    const trackPageView = () => {
      try {
        // Detect device type
        const userAgent = navigator.userAgent;
        let deviceType: 'desktop' | 'mobile' | 'tablet' = 'desktop';
        
        if (/iPad|Android(?!.*Mobile)|Tablet/i.test(userAgent)) {
          deviceType = 'tablet';
        } else if (/iPhone|Android.*Mobile|Mobile/i.test(userAgent)) {
          deviceType = 'mobile';
        }
        
        // Get country from browser locale if available
        const country = navigator.language ? 
          new Intl.DisplayNames([navigator.language], { type: 'region' })
            .of(navigator.language.split('-')[1]) : 
          undefined;
        
        // Track the page visit
        trackPageVisit({
          page: location.pathname,
          sessionId,
          deviceType,
          country,
          referrer: document.referrer,
          isNewUser
        });
        
        // Set up timer for time on page calculation
        const startTime = Date.now();
        
        // When navigating away or closing tab, record time spent
        const handleBeforeUnload = () => {
          const timeSpent = Math.floor((Date.now() - startTime) / 1000);
          trackPageVisit({
            page: location.pathname,
            sessionId,
            deviceType,
            country,
            referrer: document.referrer,
            isNewUser,
            timeOnPage: timeSpent
          });
        };
        
        window.addEventListener('beforeunload', handleBeforeUnload);
        
        return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
        };
      } catch (error) {
        console.error('Error tracking page view:', error);
      }
    };
    
    trackPageView();
  }, [location.pathname]);
  
  return null; // This component doesn't render anything
};

export default AnalyticsTracker; 